import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TitleService {

	private messageSource = new BehaviorSubject<string>("Validating your user account");
	currentTitle = this.messageSource.asObservable();

	constructor() { }

	announceTitleChange(newTitle: string) {
		this.messageSource.next(newTitle)
	}
}
